'use client';

import { ArrowRightIcon, LogInIcon } from 'lucide-react';
import { useAuth, useClerk } from '@/auth/client';
import { Button } from '@/components/ui/button';
import SaveQrCodeBtn from '@/components/qr-generator/SaveQrCodeBtn';
import { GeneratorQrCodeDownloadBtn } from '@/components/qr-generator/download-buttons';
import { useQrCodeGeneratorStore } from '@/components/provider/QrCodeConfigStoreProvider';
import { safeLocalStorage } from '@/lib/utils';
import type { CreatorExperienceId } from './experience-config';

const DRAFT_KEY = 'guidedQrDraft';

export function CreatorReviewActions({ experience }: { experience: CreatorExperienceId }) {
	const { isSignedIn, isLoaded } = useAuth();
	const { openSignIn } = useClerk();
	const { name, config, content } = useQrCodeGeneratorStore((state) => state);

	const continueAfterSignIn = () => {
		if (!isLoaded || isSignedIn) return;
		const draft = { version: 1, experience, name: name?.slice(0, 50) ?? '', savedAt: Date.now() };
		safeLocalStorage.setItem('unsavedQrContent', JSON.stringify(content));
		safeLocalStorage.setItem('unsavedQrConfig', JSON.stringify(config));
		safeLocalStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
		openSignIn({ forceRedirectUrl: '/create?resumeDraft=1' });
	};

	if (!isLoaded)
		return (
			<Button className="min-h-11" disabled>
				Loading account…
			</Button>
		);
	if (!isSignedIn) {
		return (
			<Button className="min-h-11" onClick={continueAfterSignIn}>
				<LogInIcon className="mr-2 size-4" />
				<span className="sm:hidden">Sign in</span>
				<span className="hidden sm:inline">Sign in to download and save</span>
				<ArrowRightIcon className="ml-2 size-4" />
			</Button>
		);
	}

	return (
		<div className="flex flex-col gap-2 sm:flex-row">
			<GeneratorQrCodeDownloadBtn saveOnDownload />
			<SaveQrCodeBtn qrCode={{ name: name || null, content, config }} />
		</div>
	);
}
